import logoUrl from "../../img/themes/diplomis/logo.png";
import { CONTENTFUL_ENV, ENV_NAME } from "../common/environment";
import { type CustomerFeature, FEATURE_NAME } from "../common/types/featureTypes";
import type { Invoice } from "../common/types/invoiceTypes";
import type { SupportedLocaleType } from "../common/types/languageTypes";
import { ORDERTYPE } from "../common/types/productOrderTypes";
import type { SiteConfig } from "../common/types/themeTypes";

const ALGOLIA_APPID = "KJ28FN3CEH";
const algoliaEnvironment = ENV_NAME === "prod" ? "prod" : "preprod";

const diplomisSiteConfig: SiteConfig = {
   storeId: "diplomis",
   storeCompanyName: "Diplom-Is",
   siteName: "Diplom-Is Handel",
   orderSupportEmail: "varebestilling@diplom-is.no",
   m3CompanyNumber: "500",
   m3DivisionNumber: "100",
   defaultOrderType: ORDERTYPE.WEB,
   storeLogo: {
      searchbar: {
         url: logoUrl,
         width: 55
      },
      searchbarMobile: {
         url: logoUrl,
         width: 40
      },
      footer: {
         url: logoUrl,
         width: 70,
         mobileWidth: 72
      }
   },
   mainMenuProductCategoryLevel: 1,
   showComparisonPrice: false,
   tipApiPrefix: "di-",
   faqSlug: "",
   baseUrl: "https://www.diplomishandel.no",
   filterAttributes: (variant) =>
      variant === "tilbehor" ? { customertype: "Type", accessorytype: "Kategori" } : { brand: "Merkevare" },
   papirflyApsCustomerId: "12843",
   papirflyApsImagePrefix: "",
   fetchCustomerFeatures: () => {
      return Promise.resolve([
         { name: FEATURE_NAME.subscriptionOrderAvailable, description: "Makes subscriptions available" },
         { name: FEATURE_NAME.invoicePaymentAvailable, description: "Makes invoice overview available" },
         { name: FEATURE_NAME.createOrderAvailable, description: "Allows customer to place orders" }
      ] satisfies CustomerFeature[]);
   },
   invoiceTooltipText: (_invoice: Invoice) => "",
   deliveryFee: {
      enabled: true
   },
   productAvailability: {
      enabled: true
   },
   isLegacyFilters: true,
   newCustomerForm: "https://www.diplomishandel.no/nyheter/vil-du-selge-diplom-is",
   deliveryNotes: {
      visible: false
   },
   deliveryMethod: "thirdparty",
   contentImages: {
      cloudinaryMapping: "diplomis_images"
   },
   searchConfig: {
      algoliaAppId: ALGOLIA_APPID,
      categorySearchIndexName: `products_${algoliaEnvironment}_customer_groups`,
      searchDomains: [
         {
            type: "product",
            name: "produkter",
            displayName: (locale: SupportedLocaleType) => (locale === "en-US" ? "Products" : "Produkter"),
            homePath: (_locale) => "/produkter.html",
            indexName: `products_${algoliaEnvironment}_customer_groups`,
            linkText: (_locale) => "Se alle produkter"
         },
         {
            type: "v2_article",
            name: "artikler",
            displayName: (locale: SupportedLocaleType) => (locale === "en-US" ? "Articles" : "Artikler"),
            homePath: (_locale) => "/artikler",
            indexName: `contentful_${CONTENTFUL_ENV}`,
            linkText: (_locale) => "Se alle artikler"
         }
      ]
   },
   contactForm: {
      reasons: [
         { value: "claims", label: "Reklamasjon", label_en: "Claims" },
         { value: "invoice", label: "Fakturaspørsmål / endring av fakturaadresse", label_en: "Invoice address changes" },
         { value: "delivery", label: "Ønske om levering før oppsatt leveringsdag", label_en: "Questions about ordering" },
         { value: "product_question", label: "Spørsmål om våre produkter eller sortiment", label_en: "Question about products" },
         { value: "other", label: "Annet", label_en: "Other" }
      ]
   },
   whileYouWaitMessage: "Ta frem en Royal Trippel fra fryseren, len deg tilbake og nyt et par sekunders velfortjent pause!",
   notifications: {
      categories: [
         { id: "ORDER_CONFIRMATION", name: "Ordrebekreftelse" },
         { id: "DELIVERY_CONFIRMATION", name: "Leveringsbekreftelse" },
         { id: "ORDER_DEADLINE", name: "Påminnelse om ordrefrist" }
      ],
      enableDeliveryMessages: false
   },
   orderConfirmation: {
      headerSubTitle: "Du vil motta en bestillingsbekreftelse på e-post om kort tid."
   },
   cart: {
      showReferencesByDefault: false,
      customerReferenceLabel: "Melding til sjåfør"
   },
   promotionsPage: {
      enabled: false
   },
   allowFreeProducts: true
};

export default diplomisSiteConfig;
